export default __webpack_public_path__ + "static/media/CoreUI-Icons-Brand.d898f015.ttf";